export default {
    path: {
        d: "M12,8V4L20,12L12,20V16H4V8H12Z",
    },
    properties: {
        viewBox: "0 0 24 24",
        outlined: false,
        strokeWidth: "0",
    },
};
